import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '@/components/common/ComingSoon';
import * as m from '@/paraglide/messages.js';

export const Route = createFileRoute('/{-$locale}/ratings/')({
  component: RatingsPage,
});

function RatingsPage() {
  return <ComingSoon title={m.page_ratings()} />;
}
